import React from "react";
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";

class Reportesmultas extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            desde: "",
            hasta: "",
            agente: "",
            agentes: []
        };
    }

  componentDidMount() {
    fetch(api + "usuarios", {
        headers: authHeaders()
    })
    .then(respuesta => respuesta.json())
    .then(datos => {
        this.setState({
            agentes: Array.isArray(datos) ? datos : []
        });
    });
}

    cambioAgente = (e) => {
    this.setState({ agente: e.target.value });
}
    cambioDesde = (e) => {
        this.setState({ desde: e.target.value });
    }

    cambioHasta = (e) => {
        this.setState({ hasta: e.target.value });
    }

abrirReporte = async (ruta) => {
    const { desde, hasta, agente } = this.state;

    let url = api + ruta + "?";

    if (desde) url += `desde=${desde}&`;
    if (hasta) url += `hasta=${hasta}&`;
    if (agente) url += `agente=${agente}&`;

    try {
        const respuesta = await fetch(url, {
            method: "GET",
            headers: authHeaders()
        });

        if (!respuesta.ok) {
            alert("No se pudo generar el reporte");
            return;
        }

        const blob = await respuesta.blob();
        const fileURL = window.URL.createObjectURL(blob);

        window.open(fileURL, "_blank");

    } catch (error) {
       
        alert("Error al generar el reporte");
    }
}

    render() {
        return (
            <div className="container mt-4">
                <div className="card shadow">

                    <div className="card-header bg-danger text-white">
                        <h4>
                            <i className="bi bi-file-earmark-pdf me-2"></i>
                            REPORTES DE MULTAS
                        </h4>
                    </div>

                    <div className="card-body">

                        <div className="row mb-4">
                            <div className="col-md-6">
                                <label>Fecha inicial</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={this.state.desde}
                                    onChange={this.cambioDesde}
                                />
                            </div>

                            <div className="col-md-6">
                                <label>Fecha final</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={this.state.hasta}
                                    onChange={this.cambioHasta}
                                />
                            </div>
                        </div>
                        <div className="row mb-4">
    <div className="col-md-12">
        <label>Agente</label>
       <select
    className="form-control"
    value={this.state.agente}
    onChange={this.cambioAgente}
>
    <option value="">Todos los agentes</option>

    {this.state.agentes.map((agente) => (
        <option key={agente.idusuario} value={agente.idusuario}>
            {agente.usuario}
        </option>
    ))}
</select>
    </div>
</div>
                        <div className="row">

                          <div className="col-md-3 mb-3">
                            <button
                                className="btn btn-dark w-100 p-4"
                                onClick={() => this.abrirReporte("reportes/multas/general")}
                            >
                                Reporte general
                            </button>
                        </div>

                            <div className="col-md-3 mb-3">
                                <button
                                    className="btn btn-primary w-100 p-4"
                                    onClick={() => this.abrirReporte("reportes/multas/vigentes")}
                                >
                                    Multas vigentes
                                </button>
                            </div>

                            <div className="col-md-3 mb-3">
                                <button
                                    className="btn btn-success w-100 p-4"
                                    onClick={() => this.abrirReporte("reportes/multas/pagadas")}
                                >
                                    Multas pagadas
                                </button>
                            </div>

                            <div className="col-md-3 mb-3">
                                <button
                                    className="btn btn-warning w-100 p-4"
                                    onClick={() => this.abrirReporte("reportes/multas/anuladas")}
                                >
                                    Multas anuladas
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default Reportesmultas;